import { connect } from 'react-redux';

import LearningAdminModuleSeriesTableList from '../components/LearningAdminModuleSeriesTableList';
import storage from '../../../../../lib/Storage';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import {
  loadModuleSeriesAdmin,
  loadModuleSerieIdsAdmin,
  deleteModuleSerieAdmin,
  deleteModuleSeriesAdmin,
} from '../../../../../state/modules/learningsAdmin/actions';
import { findStorageType } from '../../../../../lib/Auth';

const defaultScope = 'list';

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const action = ownProps.action;

  const result = state.learningsAdmin.getIn([
    'moduleSeriesAdmin',
    defaultScope,
    partnershipId,
    action,
    'pages',
    order,
    limit,
    page,
  ]);

  return {
    partnershipId,
    isLoading: state.learningsAdmin.get('isLoading'),
    isLoadingIds: state.learningsAdmin.get('isLoadingIds'),
    total: state.learningsAdmin.getIn([
      'moduleSeriesAdmin',
      defaultScope,
      partnershipId,
      action,
      'totalModuleSeriesAdmin',
    ]),
    ids: state.learningsAdmin.get('ids').toArray(),
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['learningModuleSeriesAdmin', x]),
                schema.learningModuleSerieAdmin,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
      : [],
    action,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadIds: (id, filter, cb) => {
      dispatch(loadModuleSerieIdsAdmin(id, filter, cb));
    },
    load: (partnershipId, action, filter, page, limit, order, scope, cb) => {
      dispatch(
        loadModuleSeriesAdmin(
          partnershipId,
          action,
          filter,
          page,
          limit,
          order,
          scope,
          cb
        )
      );
    },
    remove: (partnershipId, id, cb) => {
      dispatch(deleteModuleSerieAdmin(partnershipId, id, cb));
    },
    removes: (partnershipId, payload, cb) => {
      dispatch(deleteModuleSeriesAdmin(partnershipId, payload, cb));
    },
  };
};

const LearningAdminModuleSeriesTableListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleSeriesTableList);

export default LearningAdminModuleSeriesTableListContainer;
